module.exports = window["wc"]["wcBlocksData"];